import { useTranslation } from 'react-i18next';
import { useCreditSummary } from 'features/credits/hooks/use-credits';
import { usePlanSeats } from 'features/subscription/hooks/use-seats';
import { formatCredits } from 'features/usage/components/usage-credits';

/** Free seats on each plan and the shared top-up balance, shown above every Teams tab. */
export function TeamsFreeToAssign() {
  const { t } = useTranslation();
  const { planSeats, isLoading } = usePlanSeats(true);
  const { data: creditSummary } = useCreditSummary();

  const items = planSeats.map((entry) => `${entry.name} ${entry.available}`);
  if (creditSummary?.enabled) {
    items.push(
      t('TEAMS_SHARED_CREDITS_COUNT', {
        credits: formatCredits(creditSummary.balanceCredits),
        defaultValue: '{{credits}} shared credits',
      })
    );
  }
  if (isLoading || items.length === 0) return null;

  return (
    <p className="text-sm leading-body text-grey-600 dark:text-grey-300">
      {t('TEAMS_FREE_TO_ASSIGN', {
        items: items.join(' · '),
        defaultValue: 'Free to assign: {{items}}',
      })}
    </p>
  );
}
